import React from "react";
import css from "./Info.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Table } from "react-bootstrap";
import NodeLink from "./NodeLink";

const InfoEntry = ({ label, value, color }) => {
  return (
    <p className={css.entryInfo}>
      <b>
        {label}
        {": "}
      </b>
      {value} &nbsp;
      {!!color ? (
        <FontAwesomeIcon icon="circle" color={color} size="1x" />
      ) : null}
    </p>
  );
};

export default InfoEntry;

export const InfoLinkLabel = ({ label, value, node_type }) => {
  if (node_type !== "compartment" && node_type !== "powernode") {
    return (
      <p className={css.entryInfo}>
        <b>
          {label}
          {": "}
        </b>
        <NodeLink type={node_type} label={value} />
      </p>
    );
  } else {
    return <InfoEntry label={label} value={value} />;
  }
};

export const InfoEntryProcesses = ({ label, value }) => {
  return (
    <div>
      <p className={css.entryInfo}>
        <b>
          {label}
          {": "}
        </b>
      </p>
      <EdgeProcessTable EdgesProcessDirection={value} />
    </div>
  );
};

const EdgeProcessTable = ({ EdgesProcessDirection }) => {
  const source = EdgesProcessDirection.source;
  const target = EdgesProcessDirection.target;

  return (
    <Table striped bordered hover>
      <thead>
        <tr>
          <th>Process</th>
          <th>Direction</th>
          <th className={"text-center"}>
            {source}
            &ensp;{"<"}
            edge
            {">"}&ensp;{target}
          </th>
        </tr>
      </thead>
      <tbody>
        {EdgesProcessDirection.processDirection.map((row) => {
          if (row.span !== false) {
            return (
              <tr key={`${row.process} ${row.direction}`}>
                <td rowSpan={row.span}>{row.process}</td>
                <td>{row.direction}</td>
                <td className={"text-center"}>
                  <ArrowIcon direction={row.direction} />
                </td>
              </tr>
            );
          } else {
            return (
              <tr key={`${row.process} ${row.direction}`}>
                <td>{row.direction}</td>
                <td className={"text-center"}>
                  <ArrowIcon direction={row.direction} />
                </td>
              </tr>
            );
          }
        })}
      </tbody>
    </Table>
  );
};

export const InfoEntryPoweredge = ({ label, value }) => {
  return (
    <div>
      <p className={css.entryInfo}>
        <b>
          {label}
          {": "}
        </b>
      </p>
      <PoweredgeProcessTable PoweredgesProcessDirection={value} />
    </div>
  );
};

const PoweredgeProcessTable = ({ PoweredgesProcessDirection }) => {
  return (
    <div style={{ maxHeight: "15rem", overflow: "scroll", width: "95%" }}>
      <Table striped bordered hover style={{}}>
        <thead
          style={{
            position: "sticky",
            top: 0,
            zIndex: 1,
            backgroundColor: "#fafafa",
          }}
        >
          <tr>
            <th>Source</th>
            <th>Target</th>
            <th>Process</th>
            <th>Direction</th>
          </tr>
        </thead>
        <tbody>
          {PoweredgesProcessDirection.map((row) => (
            <tr
              key={`${row.source} ${row.target} ${row.process} ${row.direction}`}
            >
              <td>{row.source}</td>
              <td>{row.target}</td>
              <td>{row.process}</td>
              <td>
                {row.direction} <ArrowIcon direction={row.direction} />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

const ArrowIcon = ({ direction }) => {
  if (direction === "backward") {
    return <FontAwesomeIcon icon="fa-solid fa-left-long" />;
  } else if (direction === "forward") {
    return <FontAwesomeIcon icon="fa-solid fa-right-long" />;
  } else if (direction === "undirected") {
    return (
      <div
        style={{
          textAlign: "center",
          width: "10%",
          display: "inline-block",
          verticalAlign: "middle",
          borderBottom: "2px solid black",
        }}
      ></div>
    );
  }
};
